/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PensionBeneficiary } from './PensionBeneficiary';
import {
    PensionBeneficiaryFromJSON,
    PensionBeneficiaryFromJSONTyped,
    PensionBeneficiaryToJSON,
    PensionBeneficiaryToJSONTyped,
} from './PensionBeneficiary';

/**
 * 
 * @export
 * @interface SetPensionBeneficiariesRequest
 */
export interface SetPensionBeneficiariesRequest {
    /**
     * 
     * @type {Array<PensionBeneficiary>}
     * @memberof SetPensionBeneficiariesRequest
     */
    beneficiaries: Array<PensionBeneficiary>;
}

/**
 * Check if a given object implements the SetPensionBeneficiariesRequest interface.
 */
export function instanceOfSetPensionBeneficiariesRequest(value: object): value is SetPensionBeneficiariesRequest {
    if (!('beneficiaries' in value) || value['beneficiaries'] === undefined) return false;
    return true;
}

export function SetPensionBeneficiariesRequestFromJSON(json: any): SetPensionBeneficiariesRequest {
    return SetPensionBeneficiariesRequestFromJSONTyped(json, false);
}

export function SetPensionBeneficiariesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPensionBeneficiariesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'beneficiaries': ((json['beneficiaries'] as Array<any>).map(PensionBeneficiaryFromJSON)),
    };
}

export function SetPensionBeneficiariesRequestToJSON(json: any): SetPensionBeneficiariesRequest {
    return SetPensionBeneficiariesRequestToJSONTyped(json, false);
}

export function SetPensionBeneficiariesRequestToJSONTyped(value?: SetPensionBeneficiariesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beneficiaries': ((value['beneficiaries'] as Array<any>).map(PensionBeneficiaryToJSON)),
    };
}

